module.exports = __webpack_public_path__ + "static/media/pdf.2f889279.svg";